import React from 'react';
import axios from 'axios';
import AuthService from '../Services/auth.service';
import './Myprofileaddress.css';
import './Complaintitem.css';
//import SimpleReactLightbox from 'simple-react-lightbox'
//import { SRLWrapper } from "simple-react-lightbox";
import ReactLoading from 'react-loading';
import MoreVertIcon from '@mui/icons-material/MoreVert';
class Myprofileaddress extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      full_name: undefined,
      email:undefined,photos:[],check:false, Loader:'',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
}
async componentDidMount(){
  this.setState({full_name:this.props.Fname})
  this.setState({email:this.props.Email})

}

  handleSubmit = async (e) => {
    e.preventDefault();
      if(!this.Email){
        this.Email=this.state.email
      }
      const addressData= {
        full_name:this.FullName,
        email:this.Email
      }
      await AuthService.updateProfile(addressData)
            .then(response=>{ 
                this.props.handleCancel('false')
                //window.location.href = "/my-account.html"; 
            })
            .catch(err=>{console.log(err)})


  
}

handleInputChange(event) {

  const data = new FormData() 
    data.append('file', event.target.files[0])
    //data.append('doctype', 'Task Image');
    //data.append('docname', this.props.docname);
//console.warn(this.state.selectedFile);
this.setState({ Loader: <ReactLoading type="bars" color="#1ca3e3" height={50} width={45} /> }); 

    axios.post(encodeURI(process.env.REACT_APP_API_URL+'api/method/upload_file'), data, { // receive two parameter endpoint url ,form data 
    headers : {'Authorization' : process.env.REACT_APP_TOKEN, 
    'content-type': 'application/json'}
    })
    .then(res => { // then print response status
       // console.warn(res);
       // console.log(res.data['message'])
        let Fileinfo=res.data['message']
        this.setState({img:Fileinfo.file_url})
        //console.log(this.props.no)
        let fileinf={ user_image:Fileinfo.file_url}
        this.setState({photos:fileinf})
       
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
           //alert(USR_TOKEN)
                  const imgData= {
                      user_image:Fileinfo.file_url   
                  }
                 
                axios.post(encodeURI(process.env.REACT_APP_API_URL+'api/method/ecom.api.updateProfileImage'),imgData, {  
                   headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
                  })
                  .then(res => { // then print response status
                    this.setState({photos:res.data.message.image})
                    this.setState({check:true})
                    if(this.state.photos){
                    this.setState({ Loader:'' });
                    }
                  })

                }
                else{
                  alert("Not Logged in")
              }

    })
}

removePic = async (e) => {
  this.setState({ Loader: <ReactLoading type="bars" color="#1ca3e3" height={50} width={45} /> }); 
     const USR_TOKEN = localStorage.getItem("userToken")
          const imgData= {
            user_image:'/files/default-img.png'
            }
                axios.post(encodeURI(process.env.REACT_APP_API_URL+'api/method/ecom.api.updateProfileImage'),imgData, {  
                   headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
                  })
                  .then(res => { // then print response status
                    this.setState({photos:res.data.message.image})
                    this.setState({check:true})
                    if(this.state.photos){
                    this.setState({ Loader:'' });
                    }
                  })
}


  render() {
   
    /*var settings = {
      icons: {
        autoplayIcon: null,
        closeIcon: null,
        downloadIcon: null,
        fullscreenIcon: null,
        nextIcon: null,
        pauseIcon: null,
        previousIcon: null,
        thumbnailsIcon: null,
        zoomOutIcon: null
      }
      
      }*/
    return <div>

<div className="row">


  <div className="center-space">
  <div className="float-left del-img-dpdn">
  
          {/*<img src="/assets/images/logo.svg" alt="" title="" className="img-fluid" />*/} 

          <MoreVertIcon />
          <div className="delete-dpdn">
          <button
              type="button"
              className="link-button"
              onClick={this.removePic}
            >
              Remove photo
            </button>
          </div>
      </div>
  <form onSubmit={this.handleSubmit}>
      <div className="ml-3">

  <div className="hover-upload ml-3 text-center">
  <input type="file" id="file-upload" className="d-none"  hidden onChange={this.handleInputChange}/>
  <label for="file-upload" type="submit" className="upload-img ">
  {this.state.Loader ? this.state.Loader: <i className="fa fa-camera"></i> }</label>
  
  {/* 
      <SimpleReactLightbox {...settings}> 
      <SRLWrapper  > */}
     
      <img src={this.state.check ? process.env.REACT_APP_API_URL+this.state.photos : this.props.img} alt="" title="" className="avatar-img mt-4 ml-4" width="200px" height="200px"/> 
      
     {/*  </SRLWrapper>
     </SimpleReactLightbox> */}
     </div>
                    <div className="row-form  mt-3 center-space ml-3 prof-adrs">
                        <h6  className="green-label "> Full Name</h6>
                        <input className="form-controls " defaultValue ={this.state.full_name} onChange={e => this.FullName = e.target.value} type="text"    />
                    </div> 
                        
                    <div className="row-form   center-space  mb-2 ml-3 prof-adrs">
                        <h6  className="green-label ">E-mail Address</h6>
                        <input className="form-controls " value ={this.state.email} onChange={e => this.Email = e.target.value}  type="text" placeholder="" id="email" readOnly/>
                    </div>
               </div>     
                    <div className=" mb-2 mt-4  text-center">  
                      <button type="button" className="  btnn btn-hover btn-outline-success tag-btn  mb-2" onClick={e => this.props.handleCancel('false')}>Back</button>
                      <button type="button" className=" add-to-cart2 btnn tag-btn  mt-0 mb-2 "onClick={this.handleSubmit}  >Submit</button>
                    </div>

                    </form>
      </div>
      


   




</div>







    </div>
    }
}

export default Myprofileaddress;
